import React from 'react';
import '../App.css'; // S'assure que le CSS global (avec .device-list-box) est chargé

function DeviceListBox({ label, onClick, isSelected }) {
  return (
    <div
      onClick={onClick}
      className={`device-list-box${isSelected ? ' selected' : ''}`}
    >
      {label}
    </div>
  );
}

export default DeviceListBox;